import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { setAuthTokens } from '../utils/api'
import { useAuth } from '../contexts/AuthContext'
import { API_ENDPOINTS } from '../config/api'
import { PENDING_CLAIM_KEY } from '../components/SocialSignInButtons'

/** Attach a guest's just-taken response to the account, if one is pending. */
async function claimPendingResponse(accessToken: string) {
  const responseId = localStorage.getItem(PENDING_CLAIM_KEY)
  if (!responseId) return
  localStorage.removeItem(PENDING_CLAIM_KEY)
  try {
    await fetch(API_ENDPOINTS.surveys.claimResponse(responseId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
    })
  } catch { /* best-effort; the account still exists */ }
}

const AppleCallbackPage: React.FC = () => {
  const navigate = useNavigate()
  const intl = useIntl()
  const [searchParams] = useSearchParams()
  const { checkAuth } = useAuth()
  const [error, setError] = useState('')

  useEffect(() => {
    const accessToken = searchParams.get('access_token')
    const sessionToken = searchParams.get('session_token')

    if (accessToken && sessionToken) {
      setAuthTokens(accessToken, sessionToken)
      claimPendingResponse(accessToken)
        .then(() => checkAuth())
        .then(() => navigate('/dashboard', { replace: true }))
    } else {
      setError(intl.formatMessage({ id: 'auth.callback.appleFailed' }))
      setTimeout(() => navigate('/auth/signin', { replace: true }), 3000)
    }
  }, [searchParams, navigate, checkAuth, intl])

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <p className="text-error mb-2">{error}</p>
          <p className="text-sm text-foreground-muted"><FormattedMessage id="auth.callback.redirecting" /></p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-foreground-muted"><FormattedMessage id="auth.callback.completing" /></p>
      </div>
    </div>
  )
}

export default AppleCallbackPage
